import { render, staticRenderFns } from "./NotificationsEmpty.vue?vue&type=template&id=1b46a8cb&scoped=true&lang=pug"
import script from "./NotificationsEmpty.vue?vue&type=script&lang=ts"
export * from "./NotificationsEmpty.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsEmpty.vue?vue&type=style&index=0&id=1b46a8cb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b46a8cb",
  null
  
)

export default component.exports